﻿$.fn.dxCtrlBtIa = function custom_dxCtrlBtIa(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbtia dx-ctrl");
        this.createInstance(new cdxCtrlBtIa(this, option));
    }
    return this;
}

window.cdxCtrlBtIa = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        container.css({
            "border-radius": "50%",
            "position": "absolute",
            "width": "60px",
            "height": "60px",
            bottom: "10px",
            right: "10px",
            "background-color": theme.backgroundcolorTooltip,
            "border": "2px solid " + theme.color,
            "z-index":"9999999"
        })
        container.addClass("state-hover")
        container.attr("title","Posez des question à MIA, l'ia de " + parametre.nom)

        var $DivContainer = $("<div style='position:relative;height:100%;width:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo(container)
        $("<i class='fafa fafa-mia' style='font-size:300%;color:" + theme.backgroundcolorAccent + "'></i>").appendTo($DivContainer)
        $DivContainer.on("mouseenter", function () { $Close.show() })
        $DivContainer.on("mouseleave", function () { $Close.hide() })
        var $Close = $("<i class='fas fa-xmark state-hover' style='display:none;position:absolute;top:-10px;right:-5px;border-radius:50%;padding:3px;background-color:" + theme.backgroundcolorAccent + ";'></i>").appendTo($DivContainer)
        $Close.on("click", function (e) { 
            e.stopPropagation()
            container.remove()
        })

        container.on("click", function (e) {
            $("<div/>").appendTo("body").dxCtrlPopupIa({
                bddCtrl: option.bddCtrl
            })
        })
    }


    this.element = function () { return container }

    mConstruit();
}